import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcSignature = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      transform="translate(3 3)"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m13 22.1 9.1-9.1 3.9 3.9-9.1 9.1zM20 13.75l-1.875-9.375L0 0l4.375 18.125L13.75 20zM0 0l9 9" />
      <circle cx={11.5} cy={11.5} r={2.5} />
    </g>
  </svg>
);
export default SvgIcSignature;
